import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { api } from '../api'
import { ProblemBanner } from '../components/Problem'

const EXAMPLE = `title: BFM Fundamentals
description: Energy, turn circles, pursuit curves.
tags:
  - aviation
  - bfm
cards:
  - front: What is corner velocity?
    back: The lowest speed at which the aircraft can pull maximum G.
    hint: Where rate and radius are both optimal.
`

/** v1 accepts a pasted or uploaded document; a guided form arrives in v1.1 (spec §8.2). */
export default function NewDeck() {
  const navigate = useNavigate()
  const [text, setText] = useState(EXAMPLE)
  const [format, setFormat] = useState<'yaml' | 'json'>('yaml')
  const [error, setError] = useState<unknown>(null)
  const [busy, setBusy] = useState(false)

  const submit = () => {
    setBusy(true)
    setError(null)
    api
      .createDeck(text, format === 'yaml' ? 'application/yaml' : 'application/json')
      .then((deck) => navigate(`/decks/${deck.deckId}`))
      .catch(setError)
      .finally(() => setBusy(false))
  }

  return (
    <>
      <h1>New deck</h1>
      <ProblemBanner error={error} />

      <div className="row">
        <label>
          <input
            type="radio"
            checked={format === 'yaml'}
            onChange={() => setFormat('yaml')}
          />{' '}
          YAML
        </label>
        <label>
          <input
            type="radio"
            checked={format === 'json'}
            onChange={() => setFormat('json')}
          />{' '}
          JSON
        </label>
        <input
          type="file"
          accept=".yml,.yaml,.json,application/json,application/yaml"
          onChange={(event) => {
            const file = event.target.files?.[0]
            if (!file) return
            setFormat(file.name.endsWith('.json') ? 'json' : 'yaml')
            file.text().then(setText)
          }}
        />
      </div>

      <textarea
        value={text}
        spellCheck={false}
        onChange={(event) => setText(event.target.value)}
        aria-label="Deck document"
      />

      <div className="row">
        <button className="primary" onClick={submit} disabled={busy}>
          {busy ? 'Creating…' : 'Create deck'}
        </button>
        <span className="muted">Up to 200 cards and 300 KB.</span>
      </div>
    </>
  )
}
